import moment from "moment";
import React, { Component, Fragment } from "react";
import Swiper from "react-id-swiper";
import config from "../../common/config";
import { LiveScoringContext, PlayerCardContext } from "../../Context";
import { Consume } from "../../Context/Consumer";
import {
  dateFormat,
  getPlayerFromLive,
  getTeamDeadlineObj,
  getTrans,
} from "./../../common";
export class CardFixStrip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      slideIndex: 0,
      slideTo: false,
    };
  }

  componentDidMount() {
    const { matchDays, currMatchDay } = this.props;

    if (matchDays && currMatchDay) {
      this.setState({
        slideIndex: this.searchMatchDayIndex(matchDays, currMatchDay),
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { slideIndex } = prevState;
    const { currMatchDay } = prevProps;
    const { slideIndex: newSlideIndex } = this.state;
    const {
      currMatchDay: newCurrMatchDay,
      matchDays,
      onGraphClick,
    } = this.props;

    if (currMatchDay.MatchId !== newCurrMatchDay.MatchId) {
      if (matchDays && currMatchDay) {
        this.setState({
          slideIndex: this.searchMatchDayIndex(matchDays, newCurrMatchDay),
          slideTo: true,
        });
      }
    }

    // if (slideIndex !== newSlideIndex) {
    //   onGraphClick(newCurrMatchDay);
    // }
  }

  searchMatchDayIndex = (matches, currMD) => {
    let matchDay = matches;
    let slideToMd = 0;
    let fixturesNotFound = false;
    for (let i = 0; i < matchDay.length; i++) {
      if (matchDay[i].MatchId === currMD.MatchId) {
        fixturesNotFound = true;
        slideToMd = i;
        break;
      }
    }

    if (fixturesNotFound) {
      return slideToMd;
    } else {
      return matchDay.length - 1;
    }
  };

  goNext = () => {
    const { slideIndex } = this.state;
    const { matchDays, onGraphClick } = this.props;

    if (matchDays?.length) {
      if (slideIndex + 1 <= matchDays.length - 1) {
        this.setState({
          slideIndex: slideIndex + 1,
          slideTo: true,
        });

        onGraphClick(matchDays[slideIndex + 1]);
      }
    }
  };

  goBack = () => {
    const { slideIndex } = this.state;
    const { matchDays, onGraphClick } = this.props;

    if (matchDays?.length) {
      if (slideIndex - 1 >= 0) {
        this.setState({
          slideIndex: slideIndex - 1,
          slideTo: true,
        });

        onGraphClick(matchDays[slideIndex - 1]);
      }
    }
  };

  renderSwiper = () => {
    const { slideIndex, slideTo } = this.state;
    const {
      matchDays,
      onGraphClick,
      currMatchDay,
      trans,
      player,
      PlayerCardData,
      LiveScoringData,
    } = this.props;

    if (!matchDays) {
      return <Fragment />;
    }

    let matchDaysSorted = matchDays.sort((a, b) => a.GamedayId - b.GamedayId);
    let currInitialSlide = matchDaysSorted.findIndex(
      (f) => f.MatchId === currMatchDay.MatchId
    );
    const params = {
      slidesPerView: 3,
      centeredSlides: true,
      paginationClickable: true,
      observer: true,
      noSwiping: true,
      grabCursor: true,
      // freeMode: true,
      //   className: "mySwiper",
      //   scrollbar: {
      //     el: ".swiper-scrollbar",
      //     hide: true,
      //   },
      initialSlide: currInitialSlide,
    };

    return (
      // mySwiper
      <Swiper
        {...params}
        ref={(node) => {
          if (node) this.swiper = node.swiper;
          if (slideTo) {
            let currMatchIdx = matchDaysSorted.findIndex(
              (f) => f.MatchId === currMatchDay.MatchId
            );
            this.swiper.slideTo(currMatchIdx, 500, () => {});
          }
        }}
      >
        {matchDaysSorted.map((f, index) => {
          let matchDate = f.MatchDateTime;
          let displayDate = "";
          if (f.IsTbc == "1") {
            if (matchDate) {
              /* matchDate = new Date(`${matchDate}`)
					let fullDate = moment(`${matchDate}`);
					let date = fullDate.locale('en').format('DD');
					let month = fullDate.locale(config.language).format('MMM');
          displayDate =  `${date} ${month}`; */
              displayDate = getTeamDeadlineObj(
                trans,
                config.WebConfig.OffSet,
                matchDate
              ).displayDate;
            }
            displayDate = getTrans(trans, "TBC", "TBC");
          }
          if (f.MatchStatus === "2") {
            let currGameday = PlayerCardData.playerDetail.GamedayPoints.find(
              (obj) => {
                return f.MatchId === obj.MatchId;
              }
            );
            displayDate =
              (currGameday?.TotalPoints ? currGameday.TotalPoints : 0) +
              " " +
              (+currGameday?.TotalPoints === 1
                ? getTrans(trans, "pt", "Pt")
                : getTrans(trans, "pts", "pts"));
          }
          if (f.MatchStatus === "1") {
            let playerTeamData = getPlayerFromLive(
              player,
              LiveScoringData.scoring
            );
            let playerPts = playerTeamData.teamData?.TotalPoints
              ? playerTeamData.teamData?.TotalPoints
              : playerTeamData.DBDetails?.OverallPoints;
            displayDate =
              (playerPts === NaN ? 0 : playerPts ? playerPts : 0) +
              " " +
              (+playerPts === 1
                ? getTrans(trans, "pt", "Pt")
                : getTrans(trans, "pts", "pts"));
          }
          return (
            <div
              className="swiper-slide"
              key={f.MatchId}
              onClick={(e) => onGraphClick(f)}
            >
              <div className="si-cmo__matches-box">
                <div className="si-cmo__matches-title">
                  <span>
                    {getTrans(trans, "WD", "W")} <em>{f.Gameday}</em>
                  </span>
                </div>
                <div className="si-cmo__matches-cta">
                  <span>{displayDate}</span>
                </div>
              </div>
            </div>
          );
        })}
      </Swiper>
    );
  };

  render() {
    let {
      matchDays,
      player,
      currMatchDay,
      config,
      getTrans,
      trans,
      isLiveMatch,
      onGraphClick,
      PlayerCardData,
    } = this.props;
    let { slideIndex } = this.state;

    const { renderSwiper, goNext, goBack } = this;

    return (
      <div className="si-cmo__matches si-fixtures__schedule">
        {/* <div className="swiper-container mySwiper"> */}
        {renderSwiper()}

        <div
          className={
            "swiper-button-next " +
            (slideIndex + 1 === matchDays.length ? "si-disabled" : "")
          }
          onClick={(e) => goNext()}
        />

        <div
          className={
            "swiper-button-prev " + (slideIndex < 1 ? "si-disabled" : "")
          }
          onClick={(e) => goBack()}
        />
      </div>
      //   </div>
    );
  }
}

export default Consume(CardFixStrip, [PlayerCardContext, LiveScoringContext]);
